/* Build Your Box — picker de packs.
   Ce fichier ne remise RIEN : il pose la line item property `_bundle` sur chaque
   ligne ajoutee, et c'est la Shopify Function « Build Your Box » qui ramene le
   total au prix du palier. Le prix affiche ici est une promesse que la Function
   doit tenir : si les paliers changent, changer les deux. */
(function () {
  'use strict';

  var root = document.querySelector('[data-kd-box]');
  if (!root) return;

  var tiers = [];
  try {
    tiers = JSON.parse(root.getAttribute('data-tiers') || '[]')
      .map(function (t) { return { qty: Number(t.qty),
        percent: Number(t.percent) || 0, guides: Number(t.guides) || 0 }; })
      .filter(function (t) { return t.qty >= 1 && t.percent > 0; })
      .sort(function (a, b) { return a.qty - b.qty; });
  } catch (e) { tiers = []; }
  if (!tiers.length) return;

  var minQty = tiers[0].qty;
  /* Palier vise par l'utilisateur quand il clique une carte de prix. Sert
     uniquement a guider l'affichage : on ne retire jamais un jouet deja choisi. */
  var goal = null;
  var maxQty = tiers[tiers.length - 1].qty;

  var cards = Array.prototype.slice.call(root.querySelectorAll('[data-kd-item]'));
  var bar = {
    count: root.querySelector('[data-kd-count]'),
    msg: root.querySelector('[data-kd-msg]'),
    was: root.querySelector('[data-kd-was]'),
    now: root.querySelector('[data-kd-now]'),
    cta: root.querySelector('[data-kd-submit]')
  };

  /* Un seul menu deroulant ouvert a la fois. Le clic sur un declencheur remonte
     jusqu'ici : on ne ferme que si la cible est hors de tout menu. */
  var closers = [];
  function closeDropdowns() { closers.forEach(function (fn) { fn(); }); }
  document.addEventListener('click', function (e) {
    if (!e.target.closest || !e.target.closest('.kdbb__dd')) closeDropdowns();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDropdowns();
  });

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  /* Shopify remise LIGNE PAR LIGNE en TRONQUANT vers le bas, il n'arrondit pas
     le total. Une seule formule ici, utilisee partout : la barre, les paliers,
     et l'apercu quand le client vise un palier qu'il n'a pas encore atteint.
     Verifie sur un panier reel : 3 x 29,99 a -28 % donne 64,80 et non 64,78. */
  function saved(prices, percent) {
    return prices.reduce(function (sum, unit) {
      return sum + Math.floor(unit * percent / 100);
    }, 0);
  }
  function priceOf(cards_, percent) {
    var prices = cards_.map(function (c) { return Number(c.getAttribute('data-price') || 0); });
    return prices.reduce(function (a, b) { return a + b; }, 0) - saved(prices, percent);
  }

  /* ── carousel ─────────────────────────────────────────────────────
     Le defilement natif avec scroll-snap gere le swipe mobile sans code.
     Les fleches et les points ne font que piloter ce meme scroll. */
  function initCarousel(card) {
    var track = card.querySelector('[data-kd-slides]');
    if (!track) return null;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-kd-slide]'));
    var dotsWrap = card.querySelector('[data-kd-dots]');
    var prev = card.querySelector('[data-kd-prev]');
    var next = card.querySelector('[data-kd-next]');

    if (slides.length < 2) {
      if (prev) prev.hidden = true;
      if (next) next.hidden = true;
      if (dotsWrap) dotsWrap.hidden = true;
      return { goToMedia: function () {} };
    }

    var dots = slides.map(function (_, i) {
      var d = document.createElement('button');
      d.type = 'button';
      d.className = 'kdbb__dot';
      d.setAttribute('aria-label', 'Image ' + (i + 1));
      d.addEventListener('click', function () { scrollTo(i); });
      dotsWrap.appendChild(d);
      return d;
    });

    function index() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }
    function paint() {
      var i = index();
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
      prev.disabled = i <= 0;
      next.disabled = i >= slides.length - 1;
    }
    function scrollTo(i) {
      track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    }

    prev.addEventListener('click', function () { scrollTo(index() - 1); });
    next.addEventListener('click', function () { scrollTo(index() + 1); });

    var raf;
    track.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(paint);
    });
    paint();

    return {
      goToMedia: function (mediaId) {
        if (!mediaId) return;
        for (var i = 0; i < slides.length; i++) {
          if (String(slides[i].getAttribute('data-media-id')) === String(mediaId)) {
            scrollTo(i);
            return;
          }
        }
      }
    };
  }

  /* ── options et variantes ─────────────────────────────────────────
     Les vignettes de choix sont injectees ici plutot qu'en Liquid : retrouver
     une variante portant une valeur donnee demanderait une boucle imbriquee. */
  function initOptions(card, carousel) {
    var hidden = card.querySelector('[data-kd-variant]');
    var raw = card.querySelector('[data-kd-variants]');
    if (!hidden || !raw) return function () {};

    var variants = [];
    try { variants = JSON.parse(raw.textContent) || []; } catch (e) { variants = []; }
    if (!variants.length) return function () {};

    var groups = Array.prototype.slice.call(card.querySelectorAll('[data-kd-option]'));

    /* une vignette par valeur, prise sur la premiere variante qui la porte */
    groups.forEach(function (group) {
      var pos = Number(group.getAttribute('data-kd-option'));
      group.querySelectorAll('[data-kd-value]').forEach(function (btn) {
        var value = btn.getAttribute('data-kd-value');
        var match = variants.filter(function (v) {
          return v.image && v.options && v.options[pos] === value;
        })[0];
        if (!match) return;
        var img = document.createElement('img');
        img.src = match.image;
        img.alt = '';
        img.width = 40;
        img.height = 40;
        img.className = 'kdbb__value-img';
        img.loading = 'lazy';
        btn.insertBefore(img, btn.firstChild);
        btn.classList.add('has-img');
      });
    });

    /* Certaines options n'ont rien a montrer : la langue d'un jeu de cartes se lit,
       elle ne se regarde pas, et six pastilles font une colonne interminable. On
       les replie en menu deroulant. Le choix est un REGLAGE et non une devinette :
       chaque variante ayant sa propre image en base, comparer les vignettes ne
       distingue pas une option visuelle (le modele du puzzle) d'une option
       textuelle (la langue). */
    var foldNames = (root.getAttribute('data-dropdown-options') || '')
      .split(',').map(function (x) { return x.trim().toLowerCase(); })
      .filter(Boolean);

    groups.forEach(function (group) {
      var btns = Array.prototype.slice.call(group.querySelectorAll('[data-kd-value]'));
      var labelEl = group.querySelector('.kdbb__label');
      var name = labelEl ? labelEl.textContent.trim().toLowerCase() : '';
      if (foldNames.indexOf(name) === -1) return;
      if (btns.length < 2) return;

      /* Menu maison plutot qu'un <select> natif : un modele de puzzle se
         reconnait a son image, et <option> ne sait pas en porter. */
      var dd = document.createElement('div');
      dd.className = 'kdbb__dd';

      var trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'kdbb__dd-btn';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      var tImg = document.createElement('img');
      tImg.className = 'kdbb__dd-img';
      tImg.alt = '';
      tImg.width = 30;
      tImg.height = 30;
      tImg.hidden = true;
      var tTxt = document.createElement('span');
      tTxt.className = 'kdbb__dd-txt';
      var caret = document.createElement('span');
      caret.className = 'kdbb__dd-caret';
      caret.setAttribute('aria-hidden', 'true');
      trigger.appendChild(tImg);
      trigger.appendChild(tTxt);
      trigger.appendChild(caret);

      var list = document.createElement('div');
      list.className = 'kdbb__dd-list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;

      /* Une vignette identique sur chaque ligne n'apprend rien : les six langues
         d'un jeu de cartes partagent la meme photo. On ne montre l'image que
         quand elle distingue les valeurs. */
      var srcs = btns.map(function (b) {
        var t = b.querySelector('.kdbb__value-img');
        return t ? t.src : '';
      });
      var showThumbs = srcs.some(function (x) { return x !== srcs[0]; });

      function closeFold() {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }

      var rows = btns.map(function (b) {
        var row = document.createElement('button');
        row.type = 'button';
        row.className = 'kdbb__dd-row';
        row.setAttribute('role', 'option');
        var thumb = b.querySelector('.kdbb__value-img');
        if (showThumbs && thumb) {
          var im = document.createElement('img');
          im.className = 'kdbb__dd-img';
          im.src = thumb.src;
          im.alt = '';
          im.width = 30;
          im.height = 30;
          im.loading = 'lazy';
          row.appendChild(im);
        }
        var tx = document.createElement('span');
        tx.className = 'kdbb__dd-txt';
        tx.textContent = b.querySelector('.kdbb__value-txt').textContent.trim();
        row.appendChild(tx);
        row.addEventListener('click', function () {
          btns.forEach(function (x) { x.classList.toggle('is-on', x === b); });
          closeFold();
          resolve();
        });
        list.appendChild(row);
        return { row: row, btn: b };
      });

      trigger.addEventListener('click', function () {
        var wasOpen = !list.hidden;
        closeDropdowns();
        if (wasOpen) return;
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
      });
      closers.push(closeFold);

      var wrap = group.querySelector('.kdbb__values');
      wrap.hidden = true;
      group.classList.add('is-folded');
      dd.appendChild(trigger);
      dd.appendChild(list);
      group.appendChild(dd);

      /* le menu reste le miroir des boutons, qui restent la source de verite */
      group.__kdSyncFold = function () {
        var on = group.querySelector('[data-kd-value].is-on');
        rows.forEach(function (r) {
          var isOn = r.btn === on;
          var off = r.btn.classList.contains('is-off');
          r.row.classList.toggle('is-on', isOn);
          r.row.classList.toggle('is-off', off);
          r.row.disabled = off;
          r.row.setAttribute('aria-selected', isOn ? 'true' : 'false');
        });
        if (!on) return;
        tTxt.textContent = on.querySelector('.kdbb__value-txt').textContent.trim();
        var img = showThumbs ? on.querySelector('.kdbb__value-img') : null;
        tImg.hidden = !img;
        if (img) tImg.src = img.src;
      };
    });

    function chosen() {
      return groups.map(function (g) {
        var on = g.querySelector('.is-on');
        return on ? on.getAttribute('data-kd-value') : null;
      });
    }

    function resolve() {
      var want = chosen();
      var match = variants.filter(function (v) {
        return want.every(function (val, i) { return val === null || v.options[i] === val; });
      })[0];
      if (!match) return;
      hidden.value = match.id;
      card.setAttribute('data-available', match.available ? '1' : '0');
      if (carousel) carousel.goToMedia(match.mediaId);

      /* griser les valeurs qui ne menent a aucune variante achetable */
      groups.forEach(function (g, gi) {
        var others = chosen();
        g.querySelectorAll('[data-kd-value]').forEach(function (btn) {
          var test = others.slice();
          test[gi] = btn.getAttribute('data-kd-value');
          var ok = variants.some(function (v) {
            return v.available && test.every(function (val, i) {
              return val === null || v.options[i] === val;
            });
          });
          btn.classList.toggle('is-off', !ok);
        });
        if (typeof g.__kdSyncFold === 'function') g.__kdSyncFold();
      });
    }

    groups.forEach(function (group) {
      group.querySelectorAll('[data-kd-value]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          group.querySelectorAll('[data-kd-value]').forEach(function (b) {
            b.classList.toggle('is-on', b === btn);
          });
          resolve();
        });
      });
    });

    resolve();
    return resolve;
  }

  cards.forEach(function (card) {
    var carousel = initCarousel(card);
    initOptions(card, carousel);

    /* Les supplements sont replies : deroules, ils font une carte deux fois plus
       haute que les autres. Le compteur reste visible une fois replie, sinon le
       client paie une option qu'il ne voit plus. */
    var addonsWrap = card.querySelector('[data-kd-addons]');
    var paintAddons = function () {};
    if (addonsWrap) {
      var addonsBtn = addonsWrap.querySelector('[data-kd-addons-toggle]');
      var addonsList = addonsWrap.querySelector('[data-kd-addons-list]');
      var addonsBadge = addonsWrap.querySelector('[data-kd-addons-badge]');
      addonsBtn.addEventListener('click', function () {
        var opening = addonsList.hidden;
        addonsList.hidden = !opening;
        addonsBtn.setAttribute('aria-expanded', opening ? 'true' : 'false');
      });
      paintAddons = function () {
        var n = addonsWrap.querySelectorAll('[data-kd-addon-check]:checked').length;
        addonsBadge.hidden = n === 0;
        addonsBadge.textContent = n;
      };
    }

    card.querySelectorAll('[data-kd-addon]').forEach(function (addon) {
      var check = addon.querySelector('[data-kd-addon-check]');
      var field = addon.querySelector('[data-kd-addon-field]');
      if (!check) return;
      check.addEventListener('change', function () {
        if (field) {
          field.hidden = !check.checked;
          if (check.checked) {
            var input = field.querySelector('[data-kd-addon-text]');
            if (input) input.focus();
          }
        }
        paintAddons();
        render();
      });
    });
  });

  /* ── les guides offerts ────────────────────────────────────────────
     Le nombre auquel le client a droit depend du palier atteint. On remplit
     automatiquement jusqu'a ce nombre pour qu'il ne perde jamais sa valeur par
     oubli, tout en le laissant echanger : retirer puis choisir. */
  var guideEls = Array.prototype.slice.call(root.querySelectorAll('[data-kd-guide]'));
  var guidesCount = root.querySelector('[data-kd-guides-count]');

  function guidesChosen() {
    return guideEls.filter(function (g) { return g.classList.contains('is-on'); });
  }

  /* Le nombre autorise depend du palier. On ne remplit automatiquement qu'au
     CHANGEMENT de palier : sinon le guide que le client vient de retirer est
     recoche dans la foulee, et il devient impossible d'en changer. */
  var lastAllowed = null;

  function paintGuides(allowed) {
    var n = guidesChosen().length;
    guideEls.forEach(function (g) {
      var isOn = g.classList.contains('is-on');
      g.classList.toggle('is-locked', !allowed);
      g.classList.toggle('is-full', Boolean(allowed) && !isOn && n >= allowed);
      var btn = g.querySelector('[data-kd-guide-toggle]');
      if (btn) btn.setAttribute('aria-pressed', isOn ? 'true' : 'false');
    });
    if (!guidesCount) return;
    if (!allowed) {
      guidesCount.textContent = 'Pick your toys first, then choose your free guides.';
    } else if (n < allowed) {
      var left = allowed - n;
      guidesCount.textContent = n + ' of ' + allowed + ' chosen. Pick '
        + left + (left === 1 ? ' more.' : ' more.');
    } else {
      guidesCount.textContent = 'All ' + allowed
        + ' chosen. Tap one to remove it, then pick another.';
    }
  }

  function syncGuides(allowed) {
    if (allowed !== lastAllowed) {
      var on = guidesChosen();
      if (on.length > allowed) {
        on.slice(allowed).forEach(function (g) { g.classList.remove('is-on'); });
      } else if (on.length < allowed) {
        guideEls.filter(function (g) { return !g.classList.contains('is-on'); })
          .slice(0, allowed - on.length)
          .forEach(function (g) { g.classList.add('is-on'); });
      }
      lastAllowed = allowed;
    } else if (guidesChosen().length > allowed) {
      /* filet : le palier n'a pas bouge mais la selection deborde */
      guidesChosen().slice(allowed).forEach(function (g) { g.classList.remove('is-on'); });
    }
    paintGuides(allowed);
  }

  guideEls.forEach(function (g) {
    var btn = g.querySelector('[data-kd-guide-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var tier = tierFor(selected().length);
      var allowed = tier ? tier.guides : 0;
      if (!allowed) return;
      if (g.classList.contains('is-on')) {
        g.classList.remove('is-on');
      } else if (guidesChosen().length < allowed) {
        g.classList.add('is-on');
      } else {
        if (guidesCount) guidesCount.textContent =
          'That is all ' + allowed + '. Remove one first, then pick another.';
        return;
      }
      /* peindre seulement : re-remplir ici annulerait le retrait qu'on vient de faire */
      paintGuides(allowed);
    });
  });

  /* ── descriptif d'un guide ────────────────────────────────────── */
  var modal = root.querySelector('[data-kd-modal]');
  var modalBody = root.querySelector('[data-kd-modal-content]');

  function openGuideModal(g) {
    if (!modal || !modalBody) return;
    var tpl = g.querySelector('[data-kd-guide-desc]');
    if (!tpl) return;
    modalBody.innerHTML = '';
    modalBody.appendChild(tpl.content.cloneNode(true));
    if (typeof modal.showModal === 'function') modal.showModal();
    else modal.setAttribute('open', '');
  }

  function closeGuideModal() {
    if (!modal) return;
    if (typeof modal.close === 'function') modal.close();
    else modal.removeAttribute('open');
  }

  guideEls.forEach(function (g) {
    var info = g.querySelector('[data-kd-guide-info]');
    if (info) info.addEventListener('click', function () { openGuideModal(g); });
  });

  if (modal) {
    var closeBtn = root.querySelector('[data-kd-modal-close]');
    if (closeBtn) closeBtn.addEventListener('click', closeGuideModal);
    /* clic sur le fond : dialog ne le fait pas tout seul */
    modal.addEventListener('click', function (e) {
      if (e.target === modal) closeGuideModal();
    });
  }

  /* ── ce que chaque palier fait gagner ──────────────────────────────
     En dollars et pas en pourcentage : « -18 % » ne se compare a rien, « Save
     $20.78 » se compare au prix. Le montant annonce est un PLANCHER : la remise
     etant un pourcentage, les n jouets les moins chers donnent la plus petite
     somme possible, et tout autre panier rapporte davantage. On ne promet donc
     jamais plus que ce que la Function appliquera. */
  var guidePrice = Number(root.getAttribute('data-guide-price')) || 0;
  /* qty -> plancher de valeur du palier. La barre le relit pour annoncer la
     meme somme que la carte sur laquelle le client vient de cliquer. */
  var tierValue = {};

  function paintTiers() {
    var allPrices = cards
      .map(function (c) { return Number(c.getAttribute('data-price') || 0); })
      .sort(function (a, b) { return a - b; });

    root.querySelectorAll('[data-kd-tier]').forEach(function (el) {
      var qty = Number(el.getAttribute('data-kd-tier'));
      var percent = Number(el.getAttribute('data-kd-percent')) || 0;
      var nGuides = Number(el.getAttribute('data-kd-guides')) || 0;
      var picked = allPrices.slice(0, qty);
      var offToys = saved(picked, percent);
      var giftValue = nGuides * guidePrice;
      /* « from » et pas un prix sec : la remise est un pourcentage, donc la
         boite la moins chere est celle des jouets les moins chers. Tout autre
         panier coute plus, jamais moins, et la promesse tient. */
      var from = picked.reduce(function (a, b) { return a + b; }, 0) - offToys;

      tierValue[qty] = offToys + giftValue;
      el.querySelector('[data-kd-tier-from]').textContent = 'from ' + money(from);
      el.querySelector('[data-kd-tier-save]').textContent = 'Save ' + money(offToys + giftValue);
      var detail = el.querySelector('[data-kd-tier-detail]');
      detail.textContent = money(offToys) + ' off'
        + (nGuides ? ' + ' + nGuides + ' guides free (' + money(giftValue) + ')' : '');
    });
  }

  /* ── paliers et barre ─────────────────────────────────────────── */
  function selected() {
    return cards.filter(function (c) { return c.classList.contains('is-selected'); });
  }
  function tierFor(n) {
    var best = null;
    tiers.forEach(function (t) { if (t.qty <= n) best = t; });
    return best;
  }
  function nameMissing(list) {
    return list.some(function (c) {
      var input = c.querySelector('[data-kd-name]');
      return input && !input.value.trim();
    });
  }

  function render() {
    var list = selected();
    var n = list.length;
    var tier = tierFor(n);

    if (goal !== null && tier && tier.qty >= goal) goal = null;
    var highlight = goal !== null ? goal : (tier ? tier.qty : null);
    root.querySelectorAll('[data-kd-tier]').forEach(function (el) {
      var q = Number(el.getAttribute('data-kd-tier'));
      el.classList.toggle('is-active', q === highlight);
      el.classList.toggle('is-goal', goal !== null && q === goal);
    });

    cards.forEach(function (c) {
      var btn = c.querySelector('[data-kd-toggle]');
      var on = c.classList.contains('is-selected');
      btn.querySelector('[data-kd-add-label]').hidden = on;
      btn.querySelector('[data-kd-remove-label]').hidden = !on;
      btn.disabled = !on && n >= maxQty;
    });

    bar.count.textContent = n === 1 ? '1 toy chosen' : n + ' toys chosen';
    syncGuides(tier ? tier.guides : 0);

    if (goal !== null && n < goal) {
      var left = goal - n;
      bar.msg.textContent = 'Add ' + left + (left === 1 ? ' more toy' : ' more toys')
        + ' and save ' + money(tierValue[goal]) + '.';
      bar.was.hidden = true;
      bar.now.textContent = tier ? money(priceOf(list, tier.percent)) : '';
      bar.cta.disabled = !tier || nameMissing(list);
      return;
    }

    if (!tier) {
      bar.msg.textContent = 'Pick ' + (minQty - n) + ' more to unlock the box price.';
      bar.was.hidden = true;
      bar.now.textContent = '';
      bar.cta.disabled = true;
      return;
    }

    var full = list.reduce(function (sum, c) { return sum + Number(c.getAttribute('data-price') || 0); }, 0);
    var price = priceOf(list, tier.percent);
    bar.was.hidden = full <= price;
    bar.was.textContent = money(full);
    bar.now.textContent = money(price);

    /* Les guides comptent dans l'economie : ils sont dans la boite, et ils se
       vendent a l'unite sur le store. Les annoncer ici et pas sur les cartes de
       palier ferait deux chiffres differents a l'ecran au meme moment. */
    var boxSaving = full - price + tier.guides * guidePrice;

    var missing = nameMissing(list);
    if (missing) {
      bar.msg.textContent = 'Add your child’s name to finish.';
    } else if (n < maxQty) {
      var next = tierFor(n + 1) || tiers[tiers.length - 1];
      bar.msg.textContent = next.percent > tier.percent
        ? 'Add one more toy and save ' + money(tierValue[next.qty]) + '.'
        : 'You save ' + money(boxSaving) + ' on this box.';
    } else {
      bar.msg.textContent = 'You save ' + money(boxSaving) + ' on this box.';
    }
    bar.cta.disabled = missing;
  }

  root.querySelectorAll('[data-kd-tier]').forEach(function (el) {
    el.addEventListener('click', function () {
      var q = Number(el.getAttribute('data-kd-tier'));
      /* deja assez de jouets pour ce palier : on ne retire rien, on confirme */
      goal = selected().length >= q ? null : q;
      render();
      var grid = root.querySelector('.kdbb__grid');
      if (grid) grid.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  });

  cards.forEach(function (card) {
    card.querySelector('[data-kd-toggle]').addEventListener('click', function () {
      var on = card.classList.contains('is-selected');
      if (!on && selected().length >= maxQty) return;
      card.classList.toggle('is-selected', !on);
      if (!on) {
        var input = card.querySelector('[data-kd-name]');
        if (input) input.focus();
      }
      render();
    });
    var nameInput = card.querySelector('[data-kd-name]');
    if (nameInput) nameInput.addEventListener('input', render);
  });

  /* ── ajout au panier ──────────────────────────────────────────────
     renderContents() du theme rappelle open() lui-meme, mais il faut que TOUTES
     les sections qu'il veut re-rendre soient dans le fetch, sinon il jette avant
     d'y arriver et le tiroir ne s'ouvre jamais. On demande donc explicitement les
     sections que le drawer declare, et on ouvre en dernier recours. */
  function drawerSections(el) {
    try {
      var ids = el.getSectionsToRender().map(function (s) { return s.id; });
      if (ids.length) return ids.join(',');
    } catch (e) { /* API absente : on retombe sur le defaut */ }
    return 'cart-drawer,cart-icon-bubble';
  }

  function showCart(addedId) {
    var el = document.querySelector('cart-drawer');
    if (!el || typeof el.renderContents !== 'function') {
      window.location.href = '/cart';
      return Promise.resolve();
    }
    return fetch('/?sections=' + encodeURIComponent(drawerSections(el)))
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        el.classList.remove('is-empty');
        var inner = el.querySelector('.drawer__inner');
        if (inner) inner.classList.remove('is-empty');
        el.renderContents({ id: addedId, sections: sections });
        /* filet : si renderContents n'a pas ouvert, on ouvre */
        setTimeout(function () {
          if (!el.classList.contains('active') && typeof el.open === 'function') el.open();
        }, 120);
      })
      .catch(function () { window.location.href = '/cart'; });
  }

  bar.cta.addEventListener('click', function () {
    var list = selected();
    if (!tierFor(list.length) || nameMissing(list)) return;

    /* ORDRE D'ENVOI : /cart/add.js empile a l'envers, le dernier envoye ressort
       en tete du panier. On envoie donc guides, puis supplements, puis jouets,
       pour obtenir jouets / supplements / guides a l'affichage.
       cf concepts/shopify-cart-add-js-inverse-le-lot.md */
    var items = [];

    guidesChosen().forEach(function (g) {
      var vid = Number(g.getAttribute('data-variant-id'));
      if (vid) items.push({ id: vid, quantity: 1, properties: { _Free_gift: 'Yes' } });
    });

    list.forEach(function (c) {
      var parent = c.getAttribute('data-title');
      c.querySelectorAll('[data-kd-addon]').forEach(function (addon) {
        var check = addon.querySelector('[data-kd-addon-check]');
        var vid = Number(addon.getAttribute('data-variant-id'));
        if (!check || !check.checked || !vid) return;
        /* `_For` est ce qui permet au tiroir de presenter le supplement comme
           une option du produit parent plutot qu'une ligne retirable */
        var props = { _For: parent, _bundle: 'box-addon' };
        var text = addon.querySelector('[data-kd-addon-text]');
        if (text && text.value.trim()) {
          props[text.getAttribute('data-prop-name') || 'Message'] = text.value.trim();
        }
        items.push({ id: vid, quantity: 1, properties: props });
      });
    });

    list.forEach(function (c) {
      var variant = c.querySelector('[data-kd-variant]');
      var props = { _bundle: 'box' };
      var nameInput = c.querySelector('[data-kd-name]');
      if (nameInput) props['Name'] = nameInput.value.trim();
      var addons = [];
      c.querySelectorAll('[data-kd-addon]').forEach(function (addon) {
        var check = addon.querySelector('[data-kd-addon-check]');
        if (check && check.checked) addons.push(addon.getAttribute('data-addon-title'));
      });
      if (addons.length) props['Extras'] = addons.join(', ');
      items.push({ id: Number(variant.value), quantity: 1, properties: props });
    });

    var label = bar.cta.textContent;
    bar.cta.disabled = true;
    bar.cta.classList.add('is-busy');
    bar.cta.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'add failed');
          return body;
        });
      })
      .then(function (data) {
        return showCart(data.items && data.items.length ? data.items[0].id : null);
      })
      .catch(function (err) {
        bar.msg.textContent = (err && err.message) ? err.message : 'Something went wrong. Please try again.';
      })
      .then(function () {
        bar.cta.classList.remove('is-busy');
        bar.cta.textContent = label;
        bar.cta.disabled = false;
      });
  });

  paintTiers();
  render();
})();
